import { Box, Button, Drawer } from "@mui/material";
import CustomTableGrid from "components/uiComponents/CustomTableGrid";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { Form, Formik } from "formik";
import { MailRequestModel } from "model/utilModels/MailRequestModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { RequestModel } from "model/utilModels/RequestModel";
import { ResponseModel } from "model/utilModels/ResponseModel";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { RequestQuotesService } from "services/menu/requestQuotesOverviewService/RequestQuotesOverviewService";
import DisplayParticularQuoteAsDrawer from "./DisplayParticularQuoteAsDrawer";

function RequestQuotesOverview() {
  const location = useLocation();
  const [dataList, setDataList] = useState(new ResponseModel());
  const [open, setOpen] = React.useState(false);
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  });
  const [selectedQuotes, setSelectedQuotes] = useState(undefined);
  
  useEffect(() => {
    getRequestQuotesList();
  }, [
    pagination.pageNumber,
    pagination.pageSize,
    pagination.filter,
    pagination.orderBy,
    pagination.desc,
  ]);

  useEffect(() => {
    if (open === false) {
      getRequestQuotesList();
    }
  }, [open])

  // Prepare Request Body To Get Request Quots OverView Data
  const prepareRequest = async () => {
    const requestBody = new RequestModel();
    const userDetails = JSON.parse(await LocalStorageService.getUserDetails());
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;

    requestBody.companyId = userDetails.companyId;

    return requestBody;
  };

  const toggleDrawer = (newOpen: boolean, quotes: MailRequestModel) => () => {
    setSelectedQuotes(quotes)
    setOpen(newOpen);
  };

  const getRequestQuotesList = async () => {
    const requestBody = await prepareRequest();
    var res=new ResponseModel();
    
    if (location.state?.message) {
      res = await RequestQuotesService.getUnreadQuotesOnly(requestBody);
    } else {
      res = await RequestQuotesService.getRequestQuotesList(requestBody);
    }
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setDataList(res);
    }
  };

  const initialValues = {};
  const onSubmit = () => {
    getRequestQuotesList();
  };

  function convertHTMLToPlain(html) {
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }

  const columns = useMemo(
    () => [
      {
        header: "Action",
        Cell: ({ renderedCellValue, row }) => (
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Button onClick={toggleDrawer(true, row.original)} >{row.original.unreadMessageNo ? <span className="badge badge-sm bg-gradient-warning">View</span> : <span className="badge badge-sm bg-gradient-warning">Mark As Read</span>} </Button>
          </Box>
        ),
        size: 50,
      },
      {
        accessorKey: "fromCompanyName",
        header: "Sender",
        size: 150,
      },
      {
        accessorKey: "toCompanyName",
        header: "Receiver",
        size: 150,
      },
   
      {
        accessorKey: "requestSubject",
        header: "Subject",
        size: 150,
      },
      {
        header: "Message",
        Cell: ({ renderedCellValue, row }) => {
          return convertHTMLToPlain(row.original.requestMessage)
        },
        size: 200,
      },
    ],
    []
  );

  return (
    <>
      <Box sx={{ width: "100%" }} className="container-subheaders">
        <Box sx={{ borderBottom: 1, borderColor: "#ebedf3" }}>
          <div className="content-subheader">
            <h2 className="font-weight-folder">Request Quotes Overview</h2>
          </div>
        </Box>
        <div className="sub-content-sec">
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {(formik) => (
              <Form>
                <CustomTableGrid
                  item={
                    <FormikControl
                      control="materialTable"
                      tableColumn={columns}
                      tableData={dataList}
                      formikValue={formik}
                      setPagination={setPagination}
                    />
                  }
                />
              </Form>
            )}
          </Formik>
        </div>
      </Box>
      <Drawer open={open} anchor="right" onClose={toggleDrawer(false, new MailRequestModel())} >
        <DisplayParticularQuoteAsDrawer selectedQuotes={selectedQuotes} setOpen={setOpen} />
      </Drawer>
    </>

  );
}

export default RequestQuotesOverview;
